import React from "react";
import { monFetch } from "../inc/inc";
import { useState, useEffect } from "react";

const Comp = (props) => {
  const [html, setHtml] = useState("");

  async function query() {
    const res = await monFetch("/questionExport", {});
    setHtml(res.res);
  }

  useEffect(() => {
    query();
  }, []);

  return <div dangerouslySetInnerHTML={{ __html: html }}></div>;
};

export default Comp;
